module.exports = __webpack_public_path__ + "img/C2.107950b8.png";